import React from 'react'

export default ({ style }) => (
	<svg style={style} xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
		<path fillRule="evenodd" d="M9.68 2.32L5.712 6.323a1.45 1.45 0 0 0-.415 1.018v7.215c0 .795.644 1.445 1.432 1.445h6.445c.573 0 1.089-.347 1.318-.874l2.335-5.496c.601-1.43-.437-3.02-1.977-3.02h-4.046l.68-3.307a1.095 1.095 0 0 0-.293-.99 1.06 1.06 0 0 0-1.511.008zM2.432 16c.788 0 1.433-.65 1.433-1.445V8.777c0-.794-.645-1.444-1.433-1.444-.787 0-1.432.65-1.432 1.444v5.778C1 15.35 1.645 16 2.432 16z" />
	</svg>
)
